import { Component, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";

@Component({
  template: '',
})
export class RedirectAccountantComponent implements OnInit {
  constructor() { } ngOnInit() {
    window.location.href = environment.accountantUrl;
  }
}
